import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { highlightedInlineText } from 'components/common/cssStyles';

export const Wrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  color: ${colors.lightBlack};
  background-color: ${colors.baseBackground};
`;

export const MessageBodyContent = styled.div`
  flex: 1;
  white-space: pre-wrap;
  word-break: break-word;
  color: ${colors.lightBlack};
  ${highlightedInlineText};
`;

export const DateHeader = styled.div`
  display: flex;
  padding: 15px 20px 15px 20px;
  margin: ${(props) => props.isLiveChat && '0px 0px 20px 0px'};
  border-bottom: 1px solid ${colors.lightGray15};
  white-space: pre-wrap;
  font-size: 9px;
  color: ${colors.darkGray1};
  font-family: 'Lato-Regular', sans-serif;
  display: flex;
  justify-content: ${(props) => (props.isLiveChat ? 'flex-start' : 'flex-end')};
  animation-name: fadeIn;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  opacity: 0%;
  &:first-of-type {
    border-top: 0px;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;
